import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../shared/makeApiCall";
import CategoryForm from "../components/forms/categories/CategoryForm";
import DeleteCategoryForm from "../components/forms/categories/DeleteCategoryForm";
import { updateObjectInArray } from "../shared/utility";

import { SimpleNotificationType } from "../components/notifications/SimpleNotification";

export function CategoriesViewModel(logout) {
  const [loading, setLoading] = useState(true);
  const [popupModalOpen, setPopupModalOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [showSimpleNoti, setShowSimpleNoti] = useState({
    open: false,
    message: null,
    title: null,
    type: SimpleNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [categories, setCategories] = useState({
    data: [],
    total: 0,
  });
  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);

  const getCategories = async function (search, page) {
    setLoading(true);
    let callResult = await makeGetApiCall(
      `categories?page=${page}&search=${search}`
    );

    setLoading(false);
    if (callResult.success) {
      setCategories(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const upcateCategory = async function (category, values, index) {
    let callResult = await makePostApiCall(`categories/${category.id}`, values);

    if (callResult.success) {
      const categorysData = [...categories.data];
      const updatedCategory = {
        ...values,
      };

      const updatePayload = {
        index: index,
        item: updatedCategory,
      };

      const updatedCategories = updateObjectInArray(
        categorysData,
        updatePayload
      );

      const newCategories = { ...categories, data: updatedCategories };

      setCategories(newCategories);
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setShowSimpleNoti({
        open: true,
        message: null,
        title: "Category updated",
        type: SimpleNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const viewCategoryDetails = async function (category, index) {
    setSlideOver({
      childComponent: (
        <CategoryForm
          index={index}
          isEdit={true}
          category={category}
          setOpen={setSlideOver}
          actionCall={upcateCategory}
        />
      ),
      open: true,
    });
  };

  const addCategory = async function (values) {
    let callResult = await makePostApiCall(`addCategory`, values);

    if (callResult.success) {
      getCategories("", 0);
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setShowSimpleNoti({
        open: true,
        message: null,
        title: "New category added",
        type: SimpleNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddNewCategory = () => {
    setSlideOver({
      childComponent: (
        <CategoryForm actionCall={addCategory} setOpen={setSlideOver} />
      ),
      open: true,
    });
  };

  const getCategoryFilterOptions = async function () {
    let callResult = await makeGetApiCall(`getCategoryFilterOptions`);
    if (callResult.success) {
      setCategoryFilterOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const deleteCategory = async function (categoryId, replacementCategoryValue) {
    let callResult = await makePostApiCall(`deleteCategory/${categoryId}`, {
      merge_category_id: replacementCategoryValue,
    });

    if (callResult.success) {
      setPopupModalOpen({
        open: false,
        childComponent: null,
      });
      getCategories("", 0);
      setShowSimpleNoti({
        open: true,
        message: null,
        title: "Category deleted",
        type: SimpleNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openDeleteCategoryConfirmation = async function (categoryId) {
    setPopupModalOpen({
      childComponent: (
        <DeleteCategoryForm
          categoryId={categoryId}
          categoryOptions={categoryFilterOptions}
          setOpen={setPopupModalOpen}
          actionCall={deleteCategory}
        />
      ),
      open: true,
    });
  };

  return {
    getCategories,
    loading,
    openAddNewCategory,
    setCategories,
    showSimpleNoti,
    slideOver,
    categories,
    viewCategoryDetails,
    setShowSimpleNoti,
    setSlideOver,
    popupModalOpen,
    setPopupModalOpen,
    openDeleteCategoryConfirmation,
    getCategoryFilterOptions,
  };
}
